import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonInput, CommonModal, CustomPagination } from 'components'
import { changeStatusOfConsignorData, deleteConsignorData, getConsignorListData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast, { Toaster } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import { Images } from 'constants';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor';
import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import MastersFilterModal from 'modals/MastersFilterModal';
import RupeeIcon from '../Supplier/RupeeIcon';
import LoadingBar from 'react-top-loading-bar';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { ButtonHeading2 } from 'components/layout/ButtonHeading';
import { constant } from 'constants/constant';

const Consignor = (props) => {
  useDocumentTitle("Party | T360");
  const { mastersChild, masterDetailsList, setMasterDetailsList } = useContext(UserContext);
  const masterChildParty = mastersChild?.find((i) => i?.label === "Party");
  const loadingBarRef = useRef(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [consignorList, setConsignorList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const navigate = useNavigate();

  const prevFilterRef = useRef();

  const [checkboxStates, setCheckboxStates] = useState({});

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: "",
    status: 1
  });

  const toggleOffcanvas = () => {
    setShowOffcanvas(!showOffcanvas);
  };

  const getDataConsignorList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
      }
      const res = await getConsignorListData(object);
      if (res?.responseCode == 200) {
        setConsignorList(res?.data?.consignor_list);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete(); // Complete the loading bar
      }
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataConsignorList();
      prevFilterRef.current = filter;
    }
  }, [filter, showOffcanvas]);

  // useEffect(() => {
  //   getDataConsignorList();
  // }, [filter, showOffcanvas])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteConsignor = async () => {
    setLoading(true);
    try {
      let object = {
        company_id: isDelete?.company_id,
        consignor_id: isDelete?._id,
      }
      const res = await deleteConsignorData(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataConsignorList();
        setLoading(false);
        setIsDelete(false);
      } else {
        toast.success('Error !! ');
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteConsignor,
    isLoadding: loading,
  }

  useEffect(() => {
    if (consignorList && consignorList.length > 0) {
      const initialStates = consignorList.reduce((acc, item) => {
        acc[item._id] = Boolean(item?.active);
        return acc;
      }, {});
      setCheckboxStates(initialStates);
    }
  }, [consignorList]);

  useEffect(() => {
    setMasterDetailsList({})
  }, [])

  const handleCheckboxChange = (id) => {
    const newStatus = !checkboxStates[id];
    setCheckboxStates(prevStates => ({ ...prevStates, [id]: newStatus }));

    const object = {
      company_id: StorageService.getCompanyId(),
      consignor_id: id,
      active: Number(newStatus)
    };
    statusChangeofConsigner(object);
  };

  const statusChangeofConsigner = async (obj) => {
    try {
      if (obj) {
        const res = await changeStatusOfConsignorData(obj);
        if (res?.responseCode === 200) {
          toast.success(`${res?.responseMessage}`);
        } else {
          toast.error(res?.responseMessage);
          await getDataConsignorList();
        }
      }
    } catch (error) {
      toast.error(error.message);
      await getDataConsignorList();
    }
  };

  const editHandler = (data) => {
    setShowOffcanvas(data);
  };

  const handleClick = (event) => {
    event.stopPropagation();
  };

  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Party Name", accessor: "party_name" },
    { header: "Firm", accessor: "firm_id" },
    { header: "Code", accessor: "code" },
    { header: "Contact No.", accessor: "contact_nunber" },
    { header: "Party Group", accessor: "party_group" },
    { header: "City", accessor: "city" },
    { header: "Status", accessor: "status" },
    { header: "Balance", accessor: "balance" },
    { header: "Action", accessor: "action" },
  ];

  const RowListData = (data) => {

    return data?.map((item, i) => ({
      ...item,
      // serial: <>{i + 1 + filter?.limit * (filter?.page - 1)}</>,
      serial: <>
        <div className="signDropdown">
          <button className="dropbtn11"> <BsThreeDotsVertical /> </button>
          <div className="dropdownContent">
            {masterChildParty?.view === 1 &&
              <Link to={`details/${item?._id}`}
                className='_avPointer'
                style={{ textDecoration: 'none' }}
              >
                <span className='_samAnchor'>
                  <span className='viewIcon_avt'>
                    <AiOutlineEye />
                  </span>
                  &nbsp; View
                </span>
              </Link>
            }
            {masterChildParty?.edit === 1 &&
              <div
                onClick={(e) => editHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='editIcon_avt'>
                    <FiEdit />
                  </span>
                  Edit
                </span>
              </div>}

            {masterChildParty?.delete === 1 &&
              <div
                onClick={(e) => deleteHandler(item)}
                className='_avPointer'
              >
                <span className='_samAnchor'>
                  <span className='deleteIcon_avt'>
                    <FaRegTrashCan color='red' />
                  </span>
                  Delete
                </span>
              </div>
            }
          </div>
        </div>
      </>,
      party_name:
        <Link
          to={`details/${item?._id}?type=${constant.m_type.party}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
          style={{ textDecoration: 'none' }}
          onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: consignorList, details: item })) }}
        >
          {item?.name ? item?.name : '-'}
        </Link>,

      firm_id: <React.Fragment>
        {item?.firm_id?.firm ? item?.firm_id?.firm : '-'}
      </React.Fragment>,

      contact_nunber:
        <React.Fragment>
          {item?.contact_no ? item?.contact_no : '-'}
        </React.Fragment>,

      party_group:
        <React.Fragment>
          {item?.consignor_group_id?.name ? item?.consignor_group_id?.name : '-'}
        </React.Fragment>,

      city:
        <React.Fragment>
          {item?.city?.label ? item?.city?.label : '-'}
        </React.Fragment>,

      status: (
        <div className="_anvSwitcherNew form-check form-switch" style={{ width: "125px" }} onClick={(e) => handleClick(e)}>
          <input
            className="form-check-input"
            type="checkbox"
            name="actStatus"
            id={`actStatus-${item._id}`}
            autoComplete="off"
            checked={checkboxStates[item._id]}
            onChange={(e) => handleCheckboxChange(item._id)}
          />
          <span className={checkboxStates[item._id] ? "active_label_masters_status" : "disabled_label_masters_status"}>
            {checkboxStates[item._id] ? "Active" : "Disabled"}
          </span>
        </div>
      ),

      balance: item.balance ? (
        <Link
          to={`details/${item?._id}?type=${constant.m_type.party}&tab=${4}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
          style={{ textDecoration: 'none' }}
          onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: consignorList, details: item })) }}
        >
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            color: item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec'
          }}>
            <span>
              <RupeeIcon
                color={item.balance < 0 ? '#dc3545' : item.balance > 0 ? '#28a745' : '#1450ec'}
                size={20}
              />
            </span>
            <span>
              {Math.abs(item.balance).toFixed(2)}
            </span>
          </div>
        </Link>
      ) : (
        <Link
          to={`details/${item?._id}?type=${constant.m_type.party}&tab=${4}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
          style={{ textDecoration: 'none' }}
          onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: consignorList, details: item })) }}
        >
          <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            color: '#1450ec'
          }}>
            <span>
              <RupeeIcon
                color='#1450ec'
                size={20}
              />
            </span>
            <span>
              0
            </span>
          </div>
        </Link>
      )
      ,

      action:
        <React.Fragment>
          -
        </React.Fragment>
      ,
      code:
        <React.Fragment>
          {item?.consignor_code}
        </React.Fragment>
      ,

      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          {masterChildParty?.view === 1 &&
            <Link
              to={`details/${item?._id}?type=${constant.m_type.party}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`}
              className='_avPointer'
              style={{ textDecoration: 'none' }}
              onClick={(e) => { handleClick(e); setMasterDetailsList((s) => ({ ...s, list: consignorList, details: item })) }}
            >
              <span className='_samAnchor'>
                <span className='viewIcon_avt'>
                  <AiOutlineEye color="green" />
                </span>
              </span>
            </Link>}

          {masterChildParty?.edit === 1 &&
            <div
              onClick={(e) => { handleClick(e); editHandler(item) }}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='editIcon_avt'>
                  <FiEdit color="blue" />
                </span>

              </span>
            </div>}

          {masterChildParty?.delete === 1 &&
            <div
              onClick={(e) => { handleClick(e); deleteHandler(item) }}
              className='_avPointer'
            >
              <span className='_samAnchor'>
                <span className='deleteIcon_avt'>
                  <FaRegTrashCan color='red' />
                </span>

              </span>
            </div>
          }
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  const onRowClick = (e, item) => {
    navigate(`details/${item?._id}?type=${constant.m_type.party}&tab=${1}&search=${filter?.search}&offset=${+filter?.offset}&total_record=${totalItems}`)
    setMasterDetailsList((s) => ({ ...s, list: consignorList, details: item }))
  }

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />

      <ButtonHeading
        title={"Party"}
        onClick={toggleOffcanvas}
        buttonTitle={masterChildParty?.create === 1 && "Add Party"}
        showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
        listDownload={true}
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={RowListData(consignorList?.length > 0 ? consignorList : [])}
          isLoading={loading}
          onRowClick={(e, row) => {
            if (e.target.closest(".no-row-click")) return; // ignore protected cells
            onRowClick(e, row);
          }}
        />

        {consignorList?.length > 0 && <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div>}
      </div>

      {/* <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
        Confirm Modal
      </button> */}

      <div className="modal fade confirmModal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title " id="exampleModalLabel"> <img src={Images.RISKICON} alt="" /> Leave this page ?</h4>
            </div>

            <div className="modal-body">If you leave, your unsaved changes will be discarded.</div>

            <div className="modal-footer">
              <button type="button" className="_addComm_btn">Save changes</button>
              <button type="button" className="_cancel_btn" data-bs-dismiss="modal">Close</button>
            </div>

          </div>
        </div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showOffcanvas ? 'visible' : 'hidden' }}
      >
        {showOffcanvas &&
          <AddEditConsignor isOpen={showOffcanvas} onClose={(e) => { setShowOffcanvas(false); getDataConsignorList(); }} />
        }
      </div>
      <div className={showOffcanvas ? 'offBack_drop' : ''}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
      >
        {showFilterModal &&
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={filter}
            setFilter={setFilter}
          />
        }
      </div>
      <div className={showFilterModal ? 'offBack_drop' : ''}></div>

      {
        isDelete?.company_id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ? </p>
          </CommonModal>
        )
      }
    </div>
  )
}

export default Consignor